export const SET_SETTING_CHECKIN = 'SETTINGCHECKIN/SET_SETTING_CHECKIN'
export const SET_SETTINGS_CHECKIN = 'SETTINGCHECKIN/SET_SETTINGS_CHECKIN'
export const SET_LIST_CHECKIN = 'SETTINGCHECKIN/SET_LIST_CHECKIN'
export const SET_LIST_PARTICIPANT_CHECKIN = 'SETTINGCHECKIN/SET_LIST_PARTICIPANT_CHECKIN'
